/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { DataloaderInstrumentation } from './instrumentation';
export type { DataloaderInstrumentationConfig } from './types';
